<template lang="html">
  <booking-rules
    v-bind="$attrs"
    :headers="headers"
  >

    <template v-slot:itemForm="slotProps">
      <booking-rule-form v-bind="slotProps">
        <template v-slot:open:append="{item}">
          <rule-restriction-input
            v-model="item.restrictions"
          />
        </template>
      </booking-rule-form>
    </template>

    <template v-slot:item.restriction-guests="{item}">
      <span>{{displayRestriction('Max guests', item)}}</span>
    </template>

    <template v-slot:item.restriction-bookings="{item}">
      <span>{{displayRestriction('Max bookings', item)}}</span>
    </template>
  </booking-rules>
</template>

<script>
import {BookingRules, BookingRuleForm} from 'dync-booking'
import RuleRestrictionInput from './RuleRestrictionInput.vue';
import {getItemById} from '@dynapp/wc-api-generic';

export default {
  inheritAttrs: false,
  data() {
    return {
      headers: [
        {
          text: 'Active',
          value: 'active'
        },
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'From',
          value: 'from'
        },
        {
          text: 'To',
          value: 'to'
        },
        {
          text: 'Ongoing',
          value: 'ongoing'
        },
        {
          text: 'Weekdays',
          value: 'weekdays'
        },
        {
          text: 'Closed',
          value: 'closed'
        },
        {
          text: 'Open',
          value: 'open'
        },
        {
          text: 'Close',
          value: 'close'
        },
        {
          text: 'Slot length (h)',
          value: 'length'
        },
        {
          text: 'Interval (m)',
          value: 'interval'
        },
        {
          text: 'Clean time (m)',
          value: 'separation'
        },
        {
          text: 'Max guests',
          value: 'restriction-guests'
        },
        {
          text: 'Max bookings',
          value: 'restriction-bookings'
        },
        {
          text: 'Locking (m)',
          value: 'locking'
        },
        {
          text: 'Locking per slot',
          value: 'locking_per_slot'
        }
      ]
    }
  },
  methods: {
    displayRestriction(name, item) {
      var restrictionItem = getItemById(item.restrictions || [], name, 'title');
      if (restrictionItem) {
        return restrictionItem.value;
      }
      return '';
    }
  },
  components: {
    BookingRules,
    BookingRuleForm,
    RuleRestrictionInput
  }
}
</script>

<style lang="css" scoped>
</style>
